.left-pane--upgrade {
    background-color: var(--blue-lt);
}

.left-pane--credits {
    background-color: var(--ai-purple-pink-lt);
}

.right-pane-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 32px 24px 16px 24px;
}

.footer {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background-color: var(--white);
}

.plan-card {
    border: 1px solid var(--grey-xlt);
    border-radius: 8px;
    padding: 16px;
}

.plan-card--highlighted {
    border: 1px solid var(--ai-purple-primary);
    border-radius: 8px;
    padding: 16px;
}

.plan-card-content {
    background-color: var(--off-white);
    border-radius: 6px;
    padding: 10px 12px;
}
